import CommandesManager from '@features/achats/components/commandes/CommandesManager'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'
import { createFileRoute } from '@tanstack/react-router'
import { FileText } from 'lucide-react'

export const Route = createFileRoute('/_app/achats/commandes/')({
  staticData: {
    title: 'Commandes',
    icon: FileText,
    tab_icon: FileText,
    permission: PERMISSIONS.ACHATS.COMMANDES.VIEW,
    module: 'achats',
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: CommandesManager,
})
